import { ReactNode, createContext, useContext, useState } from 'react';
import { calcSizeForTv } from 'utils/index';
import { Platform } from 'utils/platform';

import { usePtBrSubtitles } from './usePtBrSubtitles';

import { usePlayer } from 'components/Player/context';

type FontSize = 'small' | 'medium' | 'large';
type SubtitleColor = 'white' | 'yellow' | 'red';

interface SubtitlesSettings {
  enabled: boolean;
  fontSize: FontSize;
  color: SubtitleColor;
  hasSubtitles: boolean;
  text: string;
  onProgress: (time: number) => void;
  setEnabled: (enabled: boolean) => void;
  setFontSize: (size: FontSize) => void;
  setColor: (color: SubtitleColor) => void;
}

const SubtitlesContext = createContext<SubtitlesSettings | undefined>(undefined);

interface SubtitlesProviderProps {
  children: ReactNode;
}

export function SubtitlesProvider({ children }: SubtitlesProviderProps) {
  const [enabled, setEnabled] = useState(false);
  const [fontSize, setFontSize] = useState<FontSize>('medium');
  const [color, setColor] = useState<SubtitleColor>('white');
  const { trackId, textTrack } = usePlayer();

  const { text, hasSubtitles, onProgress } = usePtBrSubtitles(
    trackId as string,
    textTrack as string
  );

  return (
    <SubtitlesContext.Provider
      value={{
        enabled,
        fontSize,
        color,
        hasSubtitles,
        text,
        onProgress,
        setEnabled,
        setFontSize,
        setColor,
      }}>
      {children}
    </SubtitlesContext.Provider>
  );
}

export function useSubtitlesSettings() {
  const context = useContext(SubtitlesContext);
  if (!context) {
    throw new Error('useSubtitlesSettings deve ser usado dentro de SubtitlesProvider');
  }
  return context;
}

export const FONT_SIZES: Record<FontSize, number> = {
  small: Platform.isTV ? calcSizeForTv(40) : 14,
  medium: Platform.isTV ? calcSizeForTv(48) : 16,
  large: Platform.isTV ? calcSizeForTv(54) : 18,
};

export const SUBTITLE_COLORS: Record<SubtitleColor, string> = {
  white: '#FFFFFF',
  yellow: '#FFFF00',
  red: '#FF0000',
};
